import {
    Component,
    ContentChild,
    ElementRef,
    EventEmitter,
    inject,
    Input,
    OnInit,
    Output,
    ViewEncapsulation,
} from '@angular/core';
import { ControlValueAccessor, FormControl, NgControl, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { ValidationMessagePipe } from '@shared/pipes';

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'form-input',
    templateUrl: './form-input.component.html',
    styleUrls: ['./form-input.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: true,
    imports: [
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        ReactiveFormsModule,
        ValidationMessagePipe,
        MatIconModule,
        MatTooltipModule,
    ],
    host: {
        class: 'form-input',
        '[class.hidden-hint]': 'hideHint',
    },
})
export class FormInputComponent implements ControlValueAccessor, OnInit {
    @Input()
    public label = '';

    @Input()
    public hint = '';

    @Input()
    public placeholder = '';

    @Input()
    public type = 'text';

    @Input()
    public hideRequiredMarker: boolean;

    @Input()
    public value: string;

    @Input()
    public ariaLabel: string;

    @Input()
    public disabled: boolean;

    @Input()
    public readonly = false;

    @Input()
    public hideHint?: boolean = false;

    @Input()
    public tooltip: string;

    @Input()
    public inputMode: 'numeric' | 'tel' | 'email' | 'text' = 'text';

    @Input()
    public appearance: 'fill' | 'outline' = 'fill';

    @Input()
    public iconSuffix: string;

    @Input()
    public iconPrefix: string;

    @Input()
    public showErrorMessage?: boolean = true;

    @Output()
    public enterPressed: EventEmitter<Event> = new EventEmitter<Event>();

    @Output()
    public prefixClick: EventEmitter<MouseEvent> = new EventEmitter<MouseEvent>();

    @ContentChild('prefix')
    public prefixElement: ElementRef;

    @Output()
    public suffixClick: EventEmitter<MouseEvent> = new EventEmitter<MouseEvent>();

    @ContentChild('suffix')
    public suffixElement: ElementRef;

    public inputControl: FormControl;

    private readonly ngControl: NgControl = inject(NgControl, { self: true, optional: true });

    constructor() {
        if (this.ngControl) {
            this.ngControl.valueAccessor = this;
        }
    }

    public ngOnInit(): void {
        this.inputControl = this.ngControl?.control as FormControl;
    }

    public registerOnChange(fn: (v: string) => void): void {}

    public registerOnTouched(fn: () => void): void {}

    public writeValue(value: string): void {}

    public handleSuffixClick(event: MouseEvent): void {
        event.stopPropagation();
        this.suffixClick.emit(event);
    }

    public handlePrefixClick(event: MouseEvent): void {
        event.stopPropagation();
        this.prefixClick.emit(event);
    }

    public handlePressEnter(event: Event): void {
        this.enterPressed.emit(event);
    }
}
